import styles from './confirmationDialog.module.css';
export default function ConfirmDialog({infoText, title, handleConfirm, handleCancel}: {infoText: string, title: string, handleConfirm(): void, handleCancel(): void} ) {
    return(
        <div id="confirmWindow" className={styles.confirmation_dialog}>
            <p>{infoText} {title}</p>
            <button className="button" onClick={() => handleConfirm()}>Yes</button>
            <button className="button button_black" onClick={() => handleCancel()}>Cancel</button>
        </div>
    )
}